//Add in Jquery 3 if needed, most plugins will use it.
window.$ = require('jquery');
require('intersection-observer');
require('picturefill');

//Add Jquery match height for elements
require('jquery-match-height');

//Need a Slick Carousel? Also comment out SCSS in Vendor if you dont need it.
require('slick-carousel');

//Want Greensock Animation?
//require('gsap');
//import ScrollToPlugin from '../../node_modules/gsap/src/uncompressed/plugins/ScrollToPlugin'

//Want Pushy Mobile Menu?
require('../../node_modules/@cmyee/pushy/js/pushy');
var lozad = require('lozad');

// Initialize library
lozad('.lozad', {
    load: function(el) {
        el.src = el.getAttribute('src')
        el.onload = function() {
            el.classList.add('fade')
        }
    }
}).observe();

// console.log('test')
$(document).ready(function($) {
	$('.slider').slick({
    arrows: false,
    appendDots: '.slider_dots',
    dots: true
	});
  $('#contact').click(function(event) {
    $('input:checkbox')[0].checked = false;
  });
  $('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      if (target.length) {
        // event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
        });
      }
    }
  });
    
});

$(function() {
    //caches a jQuery object containing the header element
    var header = $("nav");
    var arrow = $(".down_arrow");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 35) {
            header.addClass("scrolled");
            arrow.addClass("scrolled_arrow");
        } else {
            header.removeClass("scrolled");
            arrow.removeClass("scrolled_arrow");
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/app.js